import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";

var _templateObject,
    _effectorFileName = "/builds/gmini/ui-common/src/Paper/Paper.styled.ts",
    _templateObject2,
    _templateObject3,
    _templateObject4,
    _templateObject5,
    _templateObject6,
    _templateObject7,
    _templateObject8,
    _templateObject9,
    _templateObject10,
    _templateObject11,
    _templateObject12,
    _templateObject13;

import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import styled, { css } from 'styled-components';
var PaperRoot = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  color: rgba(0, 0, 0, 0.87);\n  transition: box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n  background-color: #fff;\n  border-radius: 4px;\n"])));
var PaperElevation1 = css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  box-shadow: 0px 2px 1px -1px rgb(0 0 0 / 20%),\n    0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%);\n"])));
var PaperElevation2 = css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%),\n    0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%);\n"])));
var PaperElevation3 = css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  box-shadow: 0px 3px 3px -2px rgb(0 0 0 / 20%),\n    0px 3px 4px 0px rgb(0 0 0 / 14%), 0px 1px 8px 0px rgb(0 0 0 / 12%);\n"])));
var PaperElevation4 = css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  box-shadow: 0px 2px 4px -1px rgb(0 0 0 / 20%),\n    0px 4px 5px 0px rgb(0 0 0 / 14%), 0px 1px 10px 0px rgb(0 0 0 / 12%);\n"])));
var PaperElevation5 = css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  box-shadow: 0px 3px 5px -1px rgb(0 0 0 / 20%),\n    0px 5px 8px 0px rgb(0 0 0 / 14%), 0px 1px 14px 0px rgb(0 0 0 / 12%);\n"])));
var PaperElevation6 = css(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  box-shadow: 0px 3px 5px -1px rgb(0 0 0 / 20%),\n    0px 6px 10px 0px rgb(0 0 0 / 14%), 0px 1px 18px 0px rgb(0 0 0 / 12%);\n"])));
var PaperElevation7 = css(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  box-shadow: 0px 4px 5px -2px rgb(0 0 0 / 20%),\n    0px 7px 10px 1px rgb(0 0 0 / 14%), 0px 2px 16px 1px rgb(0 0 0 / 12%);\n"])));
var PaperElevation8 = css(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  box-shadow: 0px 5px 5px -3px rgb(0 0 0 / 20%),\n    0px 8px 10px 1px rgb(0 0 0 / 14%), 0px 3px 14px 2px rgb(0 0 0 / 12%);\n"])));
var PaperElevation9 = css(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  box-shadow: 0px 5px 6px -3px rgb(0 0 0 / 20%),\n    0px 9px 12px 1px rgb(0 0 0 / 14%), 0px 3px 16px 2px rgb(0 0 0 / 12%);\n"])));
var PaperElevation10 = css(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  box-shadow: 0px 6px 6px -3px rgb(0 0 0 / 20%),\n    0px 10px 14px 1px rgb(0 0 0 / 14%), 0px 4px 18px 3px rgb(0 0 0 / 12%);\n"])));
var PaperElevation24 = css(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  box-shadow: 0px 11px 15px -7px rgb(0 0 0 / 20%),\n    0px 24px 38px 3px rgb(0 0 0 / 14%), 0px 9px 46px 8px rgb(0 0 0 / 12%);\n"])));
export var PaperWrapper = styled.div(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n  ", ";\n  ", "\n"])), function (props) {
  return props.className.includes('Paper-root') ? PaperRoot : '';
}, function (props) {
  switch (props.elevation) {
    case 1:
      return PaperElevation1;

    case 2:
      return PaperElevation2;

    case 3:
      return PaperElevation3;

    case 4:
      return PaperElevation4;

    case 5:
      return PaperElevation5;

    case 6:
      return PaperElevation6;

    case 7:
      return PaperElevation7;

    case 8:
      return PaperElevation8;

    case 9:
      return PaperElevation9;

    case 10:
      return PaperElevation10;

    case 24:
      return PaperElevation24;
  }
});